export default __webpack_public_path__ + "static/media/install-app-2-android.41b5c58d.jpg";